/* eslint-disable import/prefer-default-export */

export const asyncRetryWithExponentialBackOff = async (fn, retryOptions) => {
  try {
    return await fn();
  } catch (error) {
    if (retryOptions.errorMatch(error) && retryOptions.remainingTries > 0) {
      const newRetryOptions = {
        ...retryOptions,
        remainingTries: retryOptions.remainingTries - 1,
        retryDelay: retryOptions.retryDelay * 2 // exponential backoff
      };
      await new Promise(resolve => {
        setTimeout(resolve, newRetryOptions.retryDelay);
      });
      return asyncRetryWithExponentialBackOff(fn, newRetryOptions);
    }
    throw error;
  }
};

export const asyncRetryIfGatewayError = async (fn, retryOptions = {}) => {
  const defaultOptions = {
    errorMatch: error => /502 Bad|504 Gateway/.test(error.message),
    remainingTries: 3,
    retryDelay: 2_000 // initial delay of 2 seconds
  };
  return asyncRetryWithExponentialBackOff(fn, { ...defaultOptions, ...retryOptions });
};
